export enum RoleTypesEnum {
  // ENTES
  ENTES = 0,

  // Çözüm Ortağı
  SolutionProvider = 1,

  // Organizasyon Sorumlusu
  OrganizationManager = 2,

  // İş Ortağı
  BusinessPartner = 3,

  // Sistem Admin (Yalnızca Sentinel)
  SystemAdmin = 4,

  // Tesis Sorumlusu
  FacilityManager = 5,

  // Bölüm Sorumlusu / Kiracı
  SectionManager = 6
}
